<script>
import DeleteErrorModal from "../../leader-radar/error-list/DeleteErrorModal.vue";
import {CONTRACT_STATUS, CONTRACT_STATUS_LIST, CONTRACT_STATUS_MAP} from "@/core/option/admin-citime";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_CENTERS} from "@/core/services/store/center/centers.module";
import AssignPersonModal from "./AssignPersonModal.vue";
import {
  ASSIGN_CONTRACT_CITIME,
  GET_CALL_CENTER_USER,
  GET_CONTRACT_CITIME
} from "@/core/services/store/citime/citime.module";

export default {
  name: "ContractList",
  components: {AssignPersonModal, DeleteErrorModal},
  data() {
    return {
      filter: {
        student_keyword: '',
        payer_keyword: '',
        createdTime: [],
        statuses: [],
        center_id: '',
        assignee_id: null,
      },
      contractStatusList: CONTRACT_STATUS_LIST,
      centerList: [],
      tableLoading: false,
      contractList: [],
      page: 1,
      lastPage: 1,
      total: 0,
      CONTRACT_STATUS: CONTRACT_STATUS,
      assignPersonList: [],
      idContractSelect: null,
      loadingModal: false
    }
  },
  methods: {
    async getContractList(first = false,page = 1) {
      this.tableLoading = true
      try {
        this.page = page
        if (!first) {
          await this.$router.replace({query: {...this.filter,page:this.page.toString()}})
        }
        const payload = {
          page: this.page,
          ...this.filter
        }
        const response = await this.$store.dispatch(GET_CONTRACT_CITIME,payload)
        const data = response?.data
        this.contractList = data.map((contract)=>({
          id: contract?.id,
          studentName: contract?.student_name,
          studentPhone: contract?.student_phone,
          payerName: contract?.payer_name,
          payerPhone: contract?.payer_phone,
          studentCode: contract?.student_code,
          consultant: contract?.sale_name,
          registerTime: contract?.created_at,
          receiver: contract?.receiver_name,
          receiver_id: contract?.receiver_name,
          status: contract?.status,
          statusDetail: CONTRACT_STATUS_MAP[contract?.status],
          callback_at: contract?.callback_at,
        }))
        let pagination = response.pagination
        this.total = pagination?.total
        this.lastPage = pagination?.last_page
        this.page = pagination?.current_page
      }catch (e) {

      }finally {
        this.tableLoading = false
      }

    },
    clickPage(p) {
      this.getContractList(false,p)
    },
    async getListCenter() {
      const res = await this.$store.dispatch(GET_CENTERS, {
        is_edutalk: true
      })
      this.centerList = res?.data?.data.map(center => ({value: center.id, label: center.name}));
    },
    async getAssignPersonList(){
      try {
        const res = await this.$store.dispatch(GET_CALL_CENTER_USER,{})
        this.assignPersonList = res?.data.map(person => ({value: person.id, label: person.name}))
      }catch (e){
        this.$message.error('Lấy danh sách người phụ trách thất bại')
      }finally {

      }
    },
    openAssignPersonModal(item){
      this.idContractSelect = item;
      this.$bvModal.show('assign-person-modal')
    },
    async assignPerson(person){
      let payload = {
        user_id: person,
        id: this.idContractSelect ?? ''
      }
      try {
        this.loadingModal = true
        await this.$store.dispatch(ASSIGN_CONTRACT_CITIME,payload)
        this.$message.success('Phân công thành công')
        this.$bvModal.hide('assign-person-modal')
        await this.getContractList(false,this.page)
      }catch (e) {
        this.$message.error('Phân công thất bại')
      }finally {
        this.loadingModal = false
      }
      // this.loadingModal = true

    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Citime", route: ""},
      {title: "Quản lý hồ sơ Citime"},
    ]);

    await this.getListCenter()
    const query = this.$route.query
    this.filter = {
      student_keyword: query.student_keyword,
      payer_keyword: query.payer_keyword,
      createdTime: query?.createdTime ?[query?.createdTime[0],query?.createdTime[1]]: [],
      statuses: query?.status
          ? (Array.isArray(query.status) ? query.status : [query.status]).map(Number)
          : [],
      center_id:  query?.center?+query.center:''
    }
    this.page = query?.page?+query.page:1
    await this.getAssignPersonList()
    await this.getContractList(true,this.page)
  }
}
</script>

<template>
  <div class="card card-custom gutter-b">
    <!-- Header -->
    <div class="card-header">
      <div class="card-title">
        Danh sách hồ sơ vay vốn Citime
      </div>
    </div>
    <!--    body-->
    <div class="px-5">
      <div class="row flex-wrap mb-3 mt-3 gap-3">
        <div class="col-lg-2 mb-2">
          <p>Học viên</p>
          <el-input placeholder="Nhập mã học viên, SĐT, tên học viên" v-model="filter.student_keyword" size="medium"
                    clearable @input="getContractList()"></el-input>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Người trả góp</p>
          <el-input placeholder="Nhập SĐT, tên người trả góp" v-model="filter.payer_keyword" size="medium"
                    clearable @change="getContractList()"></el-input>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Người phụ trách</p>
          <el-select v-model="filter.assignee_id" placeholder="Chọn người phụ trách" size="medium" style="width:100%" filterable
                     clearable @change="getContractList()">
            <el-option
                v-for="item in assignPersonList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-3 mb-2">
          <p>Thời gian</p>
          <el-date-picker
              v-model="filter.createdTime"
              type="daterange"
              range-separator="-"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              clearable
              size="medium"
              @change="getContractList()"
          >
          </el-date-picker>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Trạng thái</p>
          <el-select multiple v-model="filter.statuses" placeholder="Chọn trạng thái" size="medium" style="width:100%" filterable
                     clearable @change="getContractList()">
            <el-option
                v-for="item in contractStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Trung tâm</p>
          <el-select v-model="filter.center_id" placeholder="Chọn trung tâm" size="medium" style="width:100%" filterable
                     clearable @change="getContractList()">
            <el-option
                v-for="item in centerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!--    body-->
      <div class="table-responsive" style="max-height: 500px">
        <table class="table table-bordered table-hover text-nowrap">
          <thead class="thead-light ">
          <tr>
            <th>Người trả góp</th>
            <th>Số điện thoại</th>
            <th>Học viên</th>
            <th>Mã học viên</th>
            <th>Tư vấn viên</th>
            <th>Thời gian đăng ký</th>
            <th>Người phụ trách</th>
            <th>Trạng thái xử lý</th>
            <th>Thời gian gọi lại</th>
            <th>Hành động</th>
          </tr>
          </thead>
          <tbody v-if="tableLoading">
          <tr>
            <td colspan="10" style="text-align: center"><i class="el-icon-loading"></i></td>
          </tr>
          </tbody>
          <tbody v-else-if="contractList.length === 0">
          <tr>
            <td colspan="10" style="text-align: center"><span>Không có dữ liệu</span></td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr v-for="item in contractList" :key="item.id">
            <td>{{ item.payerName }}</td>
            <td>{{ item.payerPhone }}</td>
            <td>{{ item.studentName }}</td>
            <td>{{ item.studentCode }}</td>
            <td>{{ item.consultant }}</td>
            <td>{{ item.registerTime }}</td>
            <td>{{ item.receiver }}</td>
            <td>
              <span class="badge" :class="`bg-${item?.statusDetail?.color}`" :style="{ color: item?.statusDetail?.color === 'secondary' || item?.statusDetail?.color === 'light' ? '' : 'white' }">
                {{ item?.statusDetail?.label }}
              </span>
            </td>
            <td>{{ item.callback_at }}</td>
            <td class="text-center">
              <router-link :to="{name:'citime-contract-detail',params:{id:item.id}}"
                           class="btn btn-xs btn-icon btn-outline-primary mr-2" title="Xem"><i
                  class="fa fa-eye"></i></router-link>
              <button class="btn btn-xs btn-icon btn-outline-success" title="Gán người phụ trách" @click="openAssignPersonModal(item.id)"><i
                  class="fab fa-buromobelexperte"></i></button>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <!-- Pagination -->
      <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-10">
        <div class="spacer"></div>
        <paginate
            v-model="page"
            :page-count="lastPage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickPage"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        />
        <div class="right-div mr-10">Tổng số bản ghi: <span style="color:#0066FF">{{ total }}</span></div>
      </div>
    </div>
    <AssignPersonModal :assignPersonList="assignPersonList" :loadingModal="loadingModal" @confirm="assignPerson"></AssignPersonModal>
  </div>
</template>

<style scoped>
.sticky-header th {
  position: sticky;
  top: 0;
  background: #f8f9fa !important;
  z-index: 9;
}

.bg-demand {
  background-color: #32e72d;
}
</style>